import React from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { PublicHomePage } from './PublicHomePage';
import { HomePage } from './HomePage';

export const ConditionalHomePage = () => {
  const identityApi = useApi(identityApiRef);
  const [isSignedIn, setIsSignedIn] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    identityApi.getBackstageIdentity().then(
      identity => setIsSignedIn(!!identity),
      () => setIsSignedIn(false),
    );
  }, [identityApi]);

  if (isSignedIn === undefined) {
    return null;
  }

  if (!isSignedIn) {
    return <PublicHomePage />;
  }

  return <HomePage />;
};
